import React from 'react'
import { useLocation } from 'react-router-dom'
import logo from '@/assets/images/logo/logo-orange.png'
import logoWhite from '@/assets/images/logo/logo-white.png'
import booking from '@/assets/images/logo/logoBooking.png'

type SizeType = 'sm'

type AttrsType = {
  height?: string
}

interface IProps {
  size?: SizeType | undefined
  bookingLogo?: boolean
  siteRedirect?: boolean
  fromBookNow?: boolean
}

export const Logo = ({
  size,
  bookingLogo = false,
  siteRedirect = false,
  fromBookNow = false,
  ...props
}: IProps) => {
  const location = useLocation()
  /*let attrs: AttrsType = {}

  if (size === 'sm') {
    attrs = {
      ...attrs,
      height: '50px',
    }
  }*/

  const openSite = () => {
    console.log('openSite: ' + siteRedirect)
    if (siteRedirect) {
      window.open(process.env.REACT_APP_SITE_URL, '_self')
    }
  }

  return (
    <img
      src={
        fromBookNow ? logoWhite : bookingLogo ? booking : logo /*
          ? booking
          : location.pathname == '/book-now' || location.pathname == '/'
          ? logoBookNowDesktop
          : logo*/
      }
      alt={'logo'}
      width={bookingLogo && !fromBookNow ? '50px' : '152px'}
      {...props}
      onClick={openSite}
    />
  )
}
